export default {
  id : 'tpi.CycleTrackingQueryHandler',
  matches : {
    objectType : 'mold',
    client : 'tpi.LineStageGanttChart'
  },
  handle( cxt ) {
    const { clientProps : { delegate } } = cxt

    return {
      delegate : delegate.parent().child( 'moldHalves' ),
      where : [
        [
          'or',
          [
            [ '$type', '=', 'cycleTracking' ],
            [ '$type', '=', 'occupancy' ]
          ],
        ],
        [ '$ack.time', '=', null ]
      ],
      ack : true
    }
  }
}
